import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/source/list';

const PageSourceList: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded: any, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageSourceList;
